import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import Subcribtion from "./Subcribtion";
const Footer = () => {
  return (
    <div className="flex flex-col">
      <Subcribtion />
      <div className="footer-camp flex">
        <div className="wrapWidth wrap flex flex-col">
          <div className="main-footer flex aic">
            <div className="left flex aic jc">
              <Link to="/">
                <img src="./images/logo-footer.svg" className="logo-img" />
              </Link>
            </div>
            <div className="center flex flex-col">
              <div className="items flex flex-col aic jc">
                <div className="item">Comprar</div>
                <div className="item">Vender</div>
                <div className="item">Quienes Somos</div>
                <div className="item">Marketplace</div>
              </div>
            </div>
            <div className="right flex flex-col">
              <div className="items flex flex-col aic jc">
                <div className="item">FAQs</div>
                <div className="item">Club</div>
                <div className="item">Contacto</div>
              </div>
            </div>
          </div>
          <div className="min-footer flex aic justify-between">
            <div className="left flex">
              © NFTs Total. Todos los derechos reservados.
            </div>
            <div className="right flex">
              <div className="min-items flex aic">
                <div className="min-item">Politica de privacidad | </div>
                <div className="min-item">Politica de cookies | </div>
                <div className="min-item"> Aviso Legal</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
